import { ShieldCheck, Loader2 } from 'lucide-react';
import { AdminPageHeader, StatCard, useFetcher } from './_P1Common';

export default function AdminSecurity() {
  const { data, loading } = useFetcher('security');
  if (loading || !data) return <AdminPageHeader icon={ShieldCheck} title="Sigurnost"><Loader2 className="animate-spin"/></AdminPageHeader>;
  return (
    <div data-testid="admin-security">
      <AdminPageHeader icon={ShieldCheck} title="Sigurnost" subtitle="Pregled sigurnosnih događaja i admin računa"/>
      <div className="px-4 md:px-6 mb-6 grid grid-cols-2 md:grid-cols-3 gap-3">
        <StatCard testid="sec-failed" label="Neuspjele prijave (24h)" value={data.failed_logins_24h} accent="amber"/>
        <StatCard testid="sec-admins" label="Admin korisnika" value={data.admin_count} accent="red"/>
        <StatCard testid="sec-banned" label="Blokiranih" value={data.banned_users}/>
      </div>
      <div className="px-4 md:px-6 pb-6 border border-zinc-800 rounded-lg mx-4 md:mx-6">
        <h3 className="px-4 py-2 border-b border-zinc-800 font-bold text-sm">Nedavne prijave</h3>
        <ul className="divide-y divide-zinc-800">
          {(data.recent_logins || []).map((e, i) => (
            <li key={i} className="px-4 py-2 text-sm flex items-center justify-between">
              <span>{e.email || e.user_id || '—'}</span>
              <span className="text-xs text-zinc-500">{(e.created_at || '').slice(0, 16).replace('T', ' ')}</span>
            </li>
          ))}
          {(data.recent_logins || []).length === 0 && <li className="px-4 py-6 text-center text-zinc-500">Nema događaja.</li>}
        </ul>
      </div>
    </div>
  );
}
